import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

export const Bold: React.FC<TypographyProps> = ({ children, ...rest }) => (
  <Typography component='span' fontWeight='bold' fontSize='inherit' {...rest}>
    {children}
  </Typography>
);
